import React from 'react';
import Navbar from '../components/Navbar';
import MusicPlayer from '../components/MusicPlayer';
import { AUDIO_FILES } from '../data/audioFiles';

export default class Voice extends React.Component {
    render() {
        return (
            <div className="dark-background d-flex justify-content-center align-items-center" style={{minHeight: '90vh', paddingBottom: '40px'}}>
                <div className="container">
                    <div className="row justify-content-center page-title-wrapper" style={{marginBottom: '25px'}}>
                        <div className="col-md-3 col-sm-10" style={{textAlign: 'center', maxWidth: '250px', minWidth: '200px'}}>
                            <h1 className="font-satisfy font-peach page-title">Voice</h1>
                            <hr className="flaired-edge-separator"/>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div id="music-player-container">
                                <MusicPlayer playlist={AUDIO_FILES}/>
                            </div>
                        </div>
                    </div>
                </div>

                <Navbar links={[
                    { text: 'Home', reference: '/home' },
                    { text: 'Resume', reference: '/resume' },
                    { text: 'Gallery', reference: '/gallery' },
                    { text: 'Voice', reference: '/voice', extraClasses: 'active-link' },
                    { text: 'Press', reference: '/press' },
                    { text: 'Contact', reference: '/contact' }
                ]}/>
            </div>
        );
    }
}